import React, { useState } from 'react';
import ReportcenterFilter from './ReportcenterFilter';
import { Block } from '@upsales/components';
import bemClass from '@upsales/components/Utils/bemClass';
import T from 'Components/Helpers/translate';
import './ReportcenterFilterClientCategory.scss';
import ReportcenterFilterRow from './ReportcenterFilterRow';
import { removeItem } from 'Store/helpers/array';
import { RCDashboardFilter } from 'Resources/ReportDashboard';
import ReportcenterFilterSearchbar from './ReportcenterFilterSearchbar';

interface Props {
	onChange: (type: keyof RCDashboardFilter, values: Array<number | 'null'>, comparison: string) => void;
	values: RCDashboardFilter;
	updateFilterHeight: () => void;
}

export const renderSelected = (values: RCDashboardFilter, returnCount: boolean = true) => {
	let res = `${T('default.accountCategories')}: `;

	if (!returnCount) {
		const clientCategoryNames = Tools.AppService.getCategories('account')
			.filter(clientCategory => {
				return values?.ClientCategory?.value?.includes?.(clientCategory.id);
			})
			.map(clientCategory => clientCategory.name);
		if (values?.ClientCategory?.value?.includes?.('null')) {
			clientCategoryNames.unshift(T('default.noClientCategory'));
		}
		res += clientCategoryNames.join(', ');
		return res;
	}

	if (values?.ClientCategory?.value?.length) {
		const length = values.ClientCategory.value.length;
		if (length >= 1) {
			res += `${length} ${(values.ClientCategory.comparison === 'eq'
				? T('default.selected')
				: T('default.excluded', { count: length })
			).toLowerCase()}`;
		}
	}

	return res;
};

const ReportcenterFilterClientCategory = ({ onChange, ...props }: Props) => {
	const classes = new bemClass('ReportcenterFilterClientCategory');
	const [searchStr, setSearchStr] = useState('');
	const categories = Tools.AppService.getCategories('account');
	const array = categories.filter(item => item.name.toLowerCase().indexOf(searchStr.toLowerCase()) !== -1) as Array<
		Partial<Omit<ReturnType<typeof Tools.AppService.getCategories>[number], 'id'>> & {
			id: number | 'null';
			name: string;
		}
	>;
	array.unshift({ id: 'null', name: T('default.noCategory') });

	const value = props.values?.ClientCategory?.value || [];
	const comparison = props.values?.ClientCategory?.comparison ?? 'eq';
	const isExclude = comparison === 'ne';

	return (
		<ReportcenterFilter
			className={classes.b()}
			renderSelected={() => renderSelected(props.values)}
			getSelectedNames={() =>
				[
					value.includes('null') ? T('default.noCategory') : null,
					...categories.filter(c => value.includes(c.id)).map(c => c.name)
				].filter(Boolean) as string[]
			}
			icon="tags"
			placeholder={`${T('default.accountCategories')}: ${T('reportcenter.filter.notActive')}`}
			value={value}
			resetFilter={() => onChange('ClientCategory', [], 'eq')}
			{...props}
		>
			<Block space="ptm prm pbm plm" backgroundColor="white" className={classes.elem('list-select').b()}>
				<Block space="mtm">
					<ReportcenterFilterSearchbar<Array<number | 'null'>>
						setSearchStr={value => setSearchStr(value)}
						searchStr={searchStr}
						placeholder={`${T('default.search')} ${T('default.accountCategories').toLowerCase()}`}
						isExclude={isExclude}
						onChange={onChange}
						field="ClientCategory"
						value={value}
					/>
				</Block>
			</Block>
			<ReportcenterFilterRow
				key={0}
				onClick={() => {
					onChange('ClientCategory', [], 'eq');
				}}
				selected={!value.length}
				title={T('filters.noFilter')}
			/>
			{array.map(row => (
				<ReportcenterFilterRow
					key={row.id}
					onClick={() => {
						const i = value.indexOf(row.id);
						onChange('ClientCategory', i !== -1 ? removeItem(value, i) : [...value, row.id], comparison);
					}}
					selected={value.indexOf(row.id) !== -1}
					title={row.name}
				/>
			))}
		</ReportcenterFilter>
	);
};

export default ReportcenterFilterClientCategory;
